/**
 * src/scripts/pages/dyad-registration/manage.js
 *
 * "Manage my registration" page — the only interactive action here is
 * cancelling a still-WAITING registration. Uses the site's lighter inline
 * confirm pattern (an in-place "Cancel? [Yes, Cancel] [No, Keep It]" row
 * toggled via .is-hidden) rather than window.confirm() or a full popup —
 * see CLAUDE.md's per-item delete confirmation guidance.
 */

document.addEventListener('DOMContentLoaded', () => {
    const openBtn = document.getElementById('dr-cancel-open-btn');
    if (!openBtn) return; // not a cancellable registration — nothing to wire up

    const confirmRow = document.getElementById('dr-cancel-confirm');
    const confirmBtn = document.getElementById('dr-cancel-confirm-btn');
    const keepBtn = document.getElementById('dr-cancel-keep-btn');
    const errorBox = document.getElementById('dr-manage-error');
    const successBox = document.getElementById('dr-manage-success');
    const actions = document.getElementById('dr-manage-actions');

    openBtn.addEventListener('click', () => {
        openBtn.classList.add('is-hidden');
        confirmRow.classList.remove('is-hidden');
    });

    keepBtn.addEventListener('click', () => {
        confirmRow.classList.add('is-hidden');
        openBtn.classList.remove('is-hidden');
    });

    confirmBtn.addEventListener('click', async () => {
        confirmBtn.disabled = true;
        keepBtn.disabled = true;
        confirmBtn.textContent = 'Cancelling…';
        errorBox && errorBox.classList.add('is-hidden');

        try {
            const response = await fetch('/dyad-registration/manage/cancel', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ token: confirmBtn.dataset.token }),
            });
            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'This registration could not be cancelled.');
            }

            if (successBox) {
                successBox.textContent = 'Your registration has been cancelled. No charge was made.';
                successBox.classList.remove('is-hidden');
            }
            actions && actions.classList.add('is-hidden');
        } catch (err) {
            if (errorBox) {
                errorBox.textContent = err.message || 'Something went wrong. Please try again.';
                errorBox.classList.remove('is-hidden');
            }
            confirmBtn.disabled = false;
            keepBtn.disabled = false;
            confirmBtn.textContent = 'Yes, Cancel';
        }
    });
});
